<template>
  <header>
    <v-slide-x-reverse-transition>
      <v-alert type="warning" class="alert_success" dismissible
        v-if="alert_close_restaurant === true">ถึงเวลาปิดร้านแล้ว กรุณาปิดร้านด้วยนะคะ</v-alert>
    </v-slide-x-reverse-transition>
    <v-app-bar-nav-icon class="d-xl-none d-lg-none d-xl-flex" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-navigation-drawer app width="250px" v-model="drawer">
      <div class="menu_all d-flex flex-column justify-space-between">
        <div>
          <div class="logo_list">
            <div class="logo">
              <img :src="beforeImage">
            </div>
          </div>
          <div class="menu_list">
            <ul>
              <li v-if="$store.state.userProfile.permission_type == 1">
                <router-link class="link_menu" to="/dashboard" exact
                  :class="{ 'router-link-active': $route.path == '/' || $route.path == '/dashboard' }">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-chart-pie</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Dashboard</div>
                      <div>รายงาน</div>
                    </div>

                  </div>
                </router-link>
              </li>
              <li>
                <router-link class="link_menu" to="/restaurant"
                  :class="{ 'router-link-active': $route.path == '/poslist' || $route.path == '/managefood' || $route.path == '/buffetmanage' || $route.path == '/orderlist' || $route.path == '/billretrospectall' || $route.path == '/billretrospect' || $route.path == '/closeretrospectall' || $route.path == '/closeretrospectdetail' || $route.path == '/summarybeforecloseshop' || $route.path == '/postabledetail' || $route.path == '/paymentfood' || $route.path == '/salereportday' || $route.path == '/quickfoodorder' || $route.path == '/addfood' || $route.path == '/addtopping' || $route.path == '/fooddetail' || $route.path == '/toppingdetail' || $route.path == '/takeoutadmin' || $route.path == '/paymenttakeoutadmin' || $route.path == '/advertisebuffet' || $route.path == '/advertisesingledishmeal' || $route.path == '/advertisetakeout' || $route.path == '/settingrestaurant' || $route.path == '/preorderlist' || $route.path == '/preorderdetail/' + $route.params.id }">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-store</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Restaurant</div>
                      <div>ร้านอาหาร</div>
                    </div>
                  </div>
                </router-link>
              </li>
              <!-- Team ทีมงาน -->
              <li v-if="$store.state.userProfile.per_my_team == 1">
                <router-link class="link_menu" to="/myteam"
                  :class="{ 'router-link-active': $route.path == '/intimework' || $route.path == '/outtimework' || $route.path == '/workschedule' || $route.path == '/manageworkschedule' || $route.path == '/allschedule' || $route.path == '/leavework' || $route.path == '/myteam' || $route.path == '/addteam' || $route.path == '/editteam' || $route.path == '/reportwork' || $route.path == '/detailreportwork' || $route.path == '/editreportwork' || $route.path == '/summary' || $route.path == '/parttimesummary' || $route.path == '/employeesummary' || $route.path == '/detailparttimesummary' || $route.path == '/detailemployeesummary' || $route.path == '/editparttimesummary' || $route.path == '/editemployeesummary' || $route.path == '/dayoffrestaurant' || $route.path == '/parttimeot' || $route.path == '/hoursworked' || $route.path == '/role' }">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-account-group</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Team</div>
                      <div>ทีมงาน</div>
                    </div>
                  </div>
                </router-link>
              </li>
              <li v-else-if="$store.state.userProfile.per_add_team == 1">
                <router-link class="link_menu" to="/addteam"
                  :class="{ 'router-link-active': $route.path == '/intimework' || $route.path == '/outtimework' || $route.path == '/workschedule' || $route.path == '/manageworkschedule' || $route.path == '/allschedule' || $route.path == '/leavework' || $route.path == '/myteam' || $route.path == '/addteam' || $route.path == '/editteam' || $route.path == '/reportwork' || $route.path == '/detailreportwork' || $route.path == '/editreportwork' || $route.path == '/summary' || $route.path == '/parttimesummary' || $route.path == '/employeesummary' || $route.path == '/detailparttimesummary' || $route.path == '/detailemployeesummary' || $route.path == '/editparttimesummary' || $route.path == '/editemployeesummary' || $route.path == '/dayoffrestaurant' || $route.path == '/parttimeot' || $route.path == '/hoursworked' || $route.path == '/role' }">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-account-group</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Team</div>
                      <div>ทีมงาน</div>
                    </div>
                  </div>
                </router-link>
              </li>
              <!-- Sales ยอดขาย -->
              <!-- <li v-if="$store.state.userProfile.per_cost_sell == 1">
                  <router-link class="link_menu" to="/dailycostreport" :class="{'router-link-active':$route.path == '/accountretrospect' || $route.path == '/accountreport' || $route.path == '/dailycostreport' || $route.path == '/remainingassetreport' || $route.path == '/incomestatement' || $route.path == '/accountsetting' || $route.path == '/salestatistic' || $route.path == '/salereport'}">
                      <div class="d-flex card_menu">
                          <div class="icon_menu">
                              <v-icon>mdi-chart-box</v-icon>
                          </div>
                          <div class="title_menu">
                              <div>Sales</div>
                              <div>ยอดขาย</div>
                          </div>
                      </div>
                  </router-link>
              </li>
              <li v-else-if="$store.state.userProfile.per_statistic_food == 1">
                  <router-link class="link_menu" to="/salestatistic" :class="{'router-link-active':$route.path == '/accountretrospect' || $route.path == '/accountreport' || $route.path == '/dailycostreport' || $route.path == '/remainingassetreport' || $route.path == '/incomestatement' || $route.path == '/accountsetting' || $route.path == '/salestatistic' || $route.path == '/salereport'}">
                      <div class="d-flex card_menu">
                          <div class="icon_menu">
                              <v-icon>mdi-chart-box</v-icon>
                          </div>
                          <div class="title_menu">
                              <div>Sales</div>
                              <div>ยอดขาย</div>
                          </div>
                      </div>
                  </router-link>
              </li>
              <li v-else-if="$store.state.userProfile.per_see_all_report == 1">
                  <router-link class="link_menu" to="/salereport" :class="{'router-link-active':$route.path == '/accountretrospect' || $route.path == '/accountreport' || $route.path == '/dailycostreport' || $route.path == '/remainingassetreport' || $route.path == '/incomestatement' || $route.path == '/accountsetting' || $route.path == '/salestatistic' || $route.path == '/salereport'}">
                      <div class="d-flex card_menu">
                          <div class="icon_menu">
                              <v-icon>mdi-chart-box</v-icon>
                          </div>
                          <div class="title_menu">
                              <div>Sales</div>
                              <div>ยอดขาย</div>
                          </div>
                      </div>
                  </router-link>
              </li> -->
              <li v-if="$store.state.userProfile.per_see_all_report == 1">
                <router-link class="link_menu" to="/salereport"
                  :class="{ 'router-link-active': $route.path == '/accountretrospect' || $route.path == '/accountreport' || $route.path == '/dailycostreport' || $route.path == '/remainingassetreport' || $route.path == '/incomestatement' || $route.path == '/accountsetting' || $route.path == '/salestatistic' || $route.path == '/salereport' }">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-chart-box</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Sales</div>
                      <div>ยอดขาย</div>
                    </div>
                  </div>
                </router-link>
              </li>
              <li v-else-if="$store.state.userProfile.per_statistic_food == 1">
                <router-link class="link_menu" to="/salestatistic"
                  :class="{ 'router-link-active': $route.path == '/accountretrospect' || $route.path == '/accountreport' || $route.path == '/dailycostreport' || $route.path == '/remainingassetreport' || $route.path == '/incomestatement' || $route.path == '/accountsetting' || $route.path == '/salestatistic' || $route.path == '/salereport' }">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-chart-box</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Sales</div>
                      <div>ยอดขาย</div>
                    </div>
                  </div>
                </router-link>
              </li>
              <!-- Stock คลัง -->
              <li>
                <router-link class="link_menu" to="/stock"
                  :class="{ 'router-link-active': $route.path == '/stock' || $route.path == '/stockreport' || $route.path == '/materialnow' || $route.path == '/stockinout' || $route.path == '/addlotin' || $route.path == '/addlotinpo' || $route.path == '/addlotout' || $route.path == '/addlotoutsummarize' || $route.path == '/alllot' || $route.path == '/lotdetailin' || $route.path == '/lotdetailinedit' || $route.path == '/lotdetailout' || $route.path == '/lotdetailoutedit' || $route.path == '/purchaseorder' || $route.path == '/purchaseordernew' || $route.path == '/purchaseordernewdetail' || $route.path == '/stockmaterial' || $route.path == '/stocktype' || $route.path == '/stocksource' || $route.path == '/stockunit' || $route.path == '/stockzone' }">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-package-variant-closed</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Stock</div>
                      <div>คลัง</div>
                    </div>
                  </div>
                </router-link>
              </li>

              <li>
                <router-link class="link_menu" to="/profile">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-account-circle</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Profile</div>
                      <div>ข้อมูลส่วนตัว</div>
                    </div>
                  </div>
                </router-link>
              </li>

              <li>
                <router-link class="link_menu" to="/usermanual">
                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-book-account-outline</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>User Manual</div>
                      <div>คู่มือการใช้งาน</div>
                    </div>
                  </div>
                </router-link>
              </li>

              <li>
                <div class="link_menu" style="cursor:pointer;" @click="logout()">

                  <div class="d-flex card_menu">
                    <div class="icon_menu">
                      <v-icon>mdi-logout</v-icon>
                    </div>
                    <div class="title_menu">
                      <div>Logout</div>
                      <div>ออกจากระบบ</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pa-1 text-center">
          <h3 class="error--text">เหลือเวลาใช้ระบบอีก</h3>
          <div class="error--text" style="font-size:14px;">วัน : ชั่วโมง : นาที : วินาที</div>
          <v-card class="pa-2 mb-2 white--text" color="error">
            {{ system_count_time_day }} : {{ system_count_time_hours }} : {{ system_count_time_minutes }} : {{
          system_count_time_seconds }}
          </v-card>
          <!-- <v-card class="pa-2 mb-2 white--text cursor_package" color="primary" @click="topUpPackage()">
            เติม Package
          </v-card> -->
        </div>

        <div class="logo_bottom">
          <div class="d-flex justify-center align-center">
            <div class="d-flex justify-center align-center img_logo_bottom">
              <img src="@/assets/new_logologinandtkfull.png">
            </div>
            <div>By ZoftConnect</div>
          </div>
          <div class="d-flex justify-center align-center mb-1">
            <a href="https://www.facebook.com/zoftconnect" target="_blank">
              <div class="d-flex justify-center align-center img_logo_bottom">
                <img src="@/assets/iconminifacebook.png">
              </div>
            </a>
            <a href="https://line.me/R/ti/p/@057tixoo?oat__id=665201" class="ml-2 mr-2" target="_blank">
              <div class="d-flex justify-center align-center img_logo_bottom">
                <img src="@/assets/iconminiline.png">
              </div>
            </a>
            <div class="d-flex justify-center align-center img_logo_bottom cursor_tel_menu" @click="open_tel = true">
              <img src="@/assets/iconminicall.png">
            </div>
          </div>
          <div class="d-flex justify-center">
            <div class="version_zoftconnect">
              ข้อมูลเวอร์ชั่น ZC 1.11
            </div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
    <v-dialog v-model="open_tel" persistent max-width="700px">
      <v-card>
        <v-card-title class="justify-space-between">
          <div>ติดต่อเรา</div>
          <div class="cursor_tel_menu" @click="open_tel = false">
            <v-icon>mdi-close</v-icon>
          </div>
        </v-card-title>
        <v-card-text class="text_tel_menu">
          <div class="contact_list align-center">
            <div>
              <div class="d-flex align-center">
                <div class="mr-1">
                  <div class="d-flex justify-center align-center img_logo_bottom">
                    <img src="@/assets/iconminifacebook.png">
                  </div>
                </div>
                <div>Facebook: ZoftConnect</div>
              </div>
              <div class="d-flex align-center mt-3 mb-3">
                <div class="mr-1">
                  <div class="d-flex justify-center align-center img_logo_bottom">
                    <img src="@/assets/iconminiline.png">
                  </div>
                </div>
                <div>Line: @zoftconnect</div>
              </div>
              <div class="d-flex align-center">
                <div class="mr-1">
                  <div class="d-flex justify-center align-center img_logo_bottom">
                    <img src="@/assets/iconminicall.png">
                  </div>
                </div>
                <div>เบอร์โทรศัพท์: 052-005-509</div>
              </div>
            </div>
            <div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3774.9338404553177!2d99.015145!3d18.890016!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x685a9770ac687feb!2sInfinity%20P%20Soft%20(Infinity%20Phenomenal%20Software)!5e0!3m2!1sth!2sth!4v1647519699852!5m2!1sth!2sth"
                width="300" height="200" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </header>
</template>

<script>
import {
  HTTP
} from "@/axios.js"
import before_image from "@/assets/new_logologinandtkfull.png";
export default {
  data() {
    return {
      open_tel: false,
      drawer: null,
      beforeImage: before_image,
      alert_close_restaurant: false,
      interval: null,
      time: Intl.DateTimeFormat('th-TH', {
        hour: 'numeric',
        minute: 'numeric',
      }).format(),
      time_close: null,
      time_out_system: null,
      system_count_time_day: null,
      system_count_time_hours: null,
      system_count_time_minutes: null,
      system_count_time_seconds: null,
    }
  },
  methods: {
    async colorRestaurant() {
      HTTP.get('/showColorAdmin', {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
        .then((response) => {
          if (response.data.successful === true) {
            this.beforeImage = response.data.logo_image
            this.time_close = response.data.time_close
            if (response.data.status_close == false && this.time >= this.time_close) {
              this.alert_close_restaurant = true
            }
            const [dateComponents, timeComponents] = response.data.time_out_system.split(' ')
            const [year, month, day] = dateComponents.split('-')
            this.time_out_system = `${year}/${month}/${day} ${timeComponents}`
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
          if (error.response.status === 500) {
            // this.$router.push('/nametakeoutuser')
          }

        })
    },
    async logout() {
      HTTP.get('/auth/logout', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
        .then((response) => {
          if (response.data.status === true) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })

    },
    async systemCountTime() {
      if (this.time_out_system) {
        const countDownToTime = new Date(this.time_out_system).getTime()
        const timeNow = new Date().getTime()
        const timeDifference = countDownToTime - timeNow
        const millisecondsInOneSecond = 1000
        const millisecondsInOneMinute = millisecondsInOneSecond * 60
        const millisecondsInOneHour = millisecondsInOneMinute * 60
        const millisecondsInOneDay = millisecondsInOneHour * 24
        const differenceInDays = timeDifference / millisecondsInOneDay
        const remainderDifferenceInHours = (timeDifference % millisecondsInOneDay) / millisecondsInOneHour
        const remainderDifferenceInMinutes = (timeDifference % millisecondsInOneHour) / millisecondsInOneMinute
        const remainderDifferenceInSeconds = (timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond
        let remainingDays = Math.floor(differenceInDays)
        let remainingHours = Math.floor(remainderDifferenceInHours)
        let remainingMinutes = Math.floor(remainderDifferenceInMinutes)
        let remainingSeconds = Math.floor(remainderDifferenceInSeconds)
        if (remainingHours < 10) {
          remainingHours = '0' + remainingHours
        }
        if (remainingMinutes < 10) {
          remainingMinutes = '0' + remainingMinutes
        }
        if (remainingSeconds < 10) {
          remainingSeconds = '0' + remainingSeconds
        }


        this.system_count_time_day = remainingDays
        this.system_count_time_hours = remainingHours
        this.system_count_time_minutes = remainingMinutes
        this.system_count_time_seconds = remainingSeconds
        if (timeDifference < 0) {
          this.$store.commit('logOutSuccess')
          // this.$router.push('/systemtimeout')
          window.location.href = "http://172.104.184.60/pricingpage/" + btoa(window.location.hostname)
          this.system_count_time_day = "0"
          this.system_count_time_hours = "00"
          this.system_count_time_minutes = "00"
          this.system_count_time_seconds = "00"

        }
      }
    },
    async topUpPackage() {
      window.location.href = "http://172.104.184.60/pricingpage/" + btoa(window.location.hostname)
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.colorRestaurant()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.time = Intl.DateTimeFormat('th-TH', {
        hour: 'numeric',
        minute: 'numeric',
      }).format()
    }, 1000)
    setInterval(() => {
      if (this.time == this.time_close) {
        this.alert_close_restaurant = true
      }
    }, 1000)
    setInterval(() => { this.systemCountTime() }, 1000)
  }
}
</script>

<style scoped>
.logo_list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.logo_list>.logo {
  width: 100px;
}

.logo_list>.logo>img {
  max-width: 100%;
}

.menu_all {
  height: 100%;
}

.menu_list>ul {
  list-style: none;
  padding: 0;
}

.menu_list>ul>li {
  padding: 5px;
}

.link_menu {
  text-decoration: none;
  display: block;
  color: #565656;
  border-radius: 4px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
}

.icon_menu {
  margin-left: 10px;
  align-self: center;
}

.title_menu {
  margin-left: 10px;
}

.link_menu:hover {
  background: linear-gradient(to top, #038cc1, #55c0e9);
  transition: 0.1s !important;
}

.link_menu:hover>.card_menu>.icon_menu>i,
.link_menu:hover>.card_menu>.title_menu {
  color: #ffffff;
  transition: 0.1s !important;
}

.router-link-active {
  background: linear-gradient(to top, #038cc1, #55c0e9);
  transition: 0.1s !important;
}

.router-link-active>.card_menu>.icon_menu>i,
.router-link-active>.card_menu>.title_menu {
  color: #ffffff;
  transition: 0.1s !important;
}

.logo_bottom {
  font-size: 14px;
}

.img_logo_bottom {
  width: 15px;
}

.img_logo_bottom>img {
  max-width: 100%;
}

.version_zoftconnect {
  font-size: 10px;
  background: #eeeeee;
  padding: 0 10px;
  border-radius: 100px;
  margin-bottom: 10px;
}

.cursor_tel_menu {
  cursor: pointer;
}

.text_tel_menu {
  font-size: 20px;
}

.contact_list {
  display: grid;
  grid-template-columns: 50% 50%;
}

.cursor_package {
  cursor: pointer;
}
</style>
